/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from 'parts/Header';
import Footer from 'parts/Footer';
import { Fade } from 'react-awesome-reveal';
import Button from 'elements/Button';
import { Products } from 'json/landingPageData';

export default function ProductDetailPage() {
  const { id } = useParams();
  const product = Products.find((p) => String(p.id) === String(id));

  useEffect(() => { window.scrollTo(0, 0); }, [id]);

  if (!product) {
    return (
      <>
        <Header />
        <section className="container mx-auto">
          <Fade bottom>
            <h1 className="text-5xl text-theme-blue text-center font-bold mt-10">Product Not Found</h1>
            <p className="font-light text-lg text-gray-400 text-center mb-12">The product you are looking for does not exist.</p>
            <div className="text-center mb-10">
              <Button type="link" className="btn px-6 btn-primary" href="/products">Back to Products</Button>
            </div>
          </Fade>
        </section>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <section className="container mx-auto">
        <Fade bottom>
          <h1 className="text-5xl text-theme-blue text-center font-bold mt-10">{product.title}</h1>
          <p className="font-light text-lg text-gray-400 text-center mb-12">{product.type}</p>
        </Fade>
        <div className="w-full">
          <img
            src={product.imageUrl}
            alt={product.title}
            className="rounded-2xl w-full h-72 sm:h-80 md:h-96 object-cover"
            loading="lazy"
            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = 'https://images.unsplash.com/photo-1520975922172-3d1c19b7b1d5?auto=format&fit=crop&w=1400&q=60'; }}
          />
        </div>

        {product.description && (
          <div className="mt-10">
            <h2 className="text-2xl font-semibold text-theme-blue mb-3">Description</h2>
            <p className="text-gray-400 leading-relaxed">{product.description}</p>
          </div>
        )}

        {Array.isArray(product.features) && product.features.length > 0 && (
          <div className="mt-8">
            <h2 className="text-2xl font-semibold text-theme-blue mb-3">Features</h2>
            <ul className="list-disc list-inside text-gray-400 space-y-1">
              {product.features.map((f) => (<li key={f}>{f}</li>))}
            </ul>
          </div>
        )}

        {Array.isArray(product.techStack) && product.techStack.length > 0 && (
          <div className="mt-8">
            <h2 className="text-2xl font-semibold text-theme-blue mb-3">Tech Stack</h2>
            <div className="flex flex-wrap gap-2">
              {product.techStack.map((t) => (
                <span key={t} className="px-3 py-1 bg-gray-800 text-gray-200 rounded-full text-sm">{t}</span>
              ))}
            </div>
          </div>
        )}

        <div className="my-12">
          <Button type="link" href="/discuss-project" className="btn btn-primary px-6">Request Quote</Button>
        </div>
      </section>
      <Footer />
    </>
  );
}
